/* eslint-disable sonarjs/no-selector-parameter -- Angular pipe requires a single transform entry point */
import { Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';

@Pipe({
    name: 'visibilityLocale',
    standalone: true,
})
export class VisibilityLocalePipe implements PipeTransform {
    transform(value: boolean): string {
        return value ? this.internalLabel() : this.externalLabel();
    }

    private internalLabel(): string {
        return translate('ASSESSMENT.AD_HOC_TASK.INTERNAL');
    }

    private externalLabel(): string {
        return translate('ASSESSMENT.AD_HOC_TASK.EXTERNAL');
    }
}
